module.exports = __webpack_public_path__ + "static/media/答疑@2x.c68012da.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/答疑@2x.png
// module id = 1594
// module chunks = 0